/*
 * @Author: Teemo Ding
 * @Date: 2021-11-25 14:17:25
 * @LastEditTime: 2021-11-25 14:17:46
 * @LastEditors: Teemo Ding
 * @FilePath: /unifyxp-v2-store-portal/src/types/common/logisticMethod.ts
 */
export enum LogisticMethod {
  Delivery = 'Delivery',
  ParcelLocker = 'ParcelLocker',
  ClickCollect = 'ClickCollect',
  Digital = 'Digital',
  virtualProductLogisticsMethod = 'virtualProductLogisticsMethod',
}
